import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import SwitchListSecondary from './SwitchListSecondary';
import ClientProvider from './client';
export default createDemo(import.meta.url, SwitchListSecondary, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/lists/demos/switch-secondary/SwitchListSecondary.tsx",
    "fileName": "SwitchListSecondary.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport List from '@mui/material/List';\nimport ListItem from '@mui/material/ListItem';\nimport ListItemIcon from '@mui/material/ListItemIcon';\nimport ListItemText from '@mui/material/ListItemText';\nimport ListSubheader from '@mui/material/ListSubheader';\nimport Switch from '@mui/material/Switch';\nimport WifiIcon from '@mui/icons-material/Wifi';\nimport BluetoothIcon from '@mui/icons-material/Bluetooth';\n\nexport default function SwitchListSecondary() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [checked, setChecked] = React.useState(['wifi']);\n\n  const handleToggle = (value: string) => () => {\n    const currentIndex = checked.indexOf(value);\n    const newChecked = [...checked];\n\n    if (currentIndex === -1) {\n      newChecked.push(value);\n    } else {\n      newChecked.splice(currentIndex, 1);\n    }\n\n    setChecked(newChecked);\n  };\n\n  return (\n    <List\n      sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}\n      subheader={<ListSubheader>Settings</ListSubheader>}\n    >\n      <ListItem>\n        <ListItemIcon>\n          <WifiIcon />\n        </ListItemIcon>\n        <ListItemText id=\"switch-list-label-wifi\" primary=\"Wi-Fi\" />\n        <Switch\n          edge=\"end\"\n          onChange={handleToggle('wifi')}\n          checked={checked.includes('wifi')}\n          slotProps={{\n            input: { 'aria-labelledby': 'switch-list-label-wifi' },\n          }}\n        />\n      </ListItem>\n      <ListItem>\n        <ListItemIcon>\n          <BluetoothIcon />\n        </ListItemIcon>\n        <ListItemText id=\"switch-list-label-bluetooth\" primary=\"Bluetooth\" />\n        <Switch\n          edge=\"end\"\n          onChange={handleToggle('bluetooth')}\n          checked={checked.includes('bluetooth')}\n          slotProps={{\n            input: { 'aria-labelledby': 'switch-list-label-bluetooth' },\n          }}\n        />\n      </ListItem>\n    </List>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 62,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport List from '@mui/material/List';\nimport ListItem from '@mui/material/ListItem';\nimport ListItemIcon from '@mui/material/ListItemIcon';\nimport ListItemText from '@mui/material/ListItemText';\nimport ListSubheader from '@mui/material/ListSubheader';\nimport Switch from '@mui/material/Switch';\nimport WifiIcon from '@mui/icons-material/Wifi';\nimport BluetoothIcon from '@mui/icons-material/Bluetooth';\n\nexport default function SwitchListSecondary() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [checked, setChecked] = React.useState(['wifi']);\n\n  const handleToggle = (value: string) => () => {\n    const currentIndex = checked.indexOf(value);\n    const newChecked = [...checked];\n\n    if (currentIndex === -1) {\n      newChecked.push(value);\n    } else {\n      newChecked.splice(currentIndex, 1);\n    }\n\n    setChecked(newChecked);\n  };\n\n  return (\n    <List\n      sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}\n      subheader={<ListSubheader>Settings</ListSubheader>}\n    >\n      <ListItem>\n        <ListItemIcon>\n          <WifiIcon />\n        </ListItemIcon>\n        <ListItemText id=\"switch-list-label-wifi\" primary=\"Wi-Fi\" />\n        <Switch\n          edge=\"end\"\n          onChange={handleToggle('wifi')}\n          checked={checked.includes('wifi')}\n          slotProps={{\n            input: { 'aria-labelledby': 'switch-list-label-wifi' },\n          }}\n        />\n      </ListItem>\n      <ListItem>\n        <ListItemIcon>\n          <BluetoothIcon />\n        </ListItemIcon>\n        <ListItemText id=\"switch-list-label-bluetooth\" primary=\"Bluetooth\" />\n        <Switch\n          edge=\"end\"\n          onChange={handleToggle('bluetooth')}\n          checked={checked.includes('bluetooth')}\n          slotProps={{\n            input: { 'aria-labelledby': 'switch-list-label-bluetooth' },\n          }}\n        />\n      </ListItem>\n    </List>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 62,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/List",
      "@mui/material/ListItem",
      "@mui/material/ListItemIcon",
      "@mui/material/ListItemText",
      "@mui/material/ListSubheader",
      "@mui/material/Switch",
      "@mui/icons-material/Wifi",
      "@mui/icons-material/Bluetooth"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
